import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtilsService } from './http-utils.service';
import { Observable, catchError, map, mergeMap, of } from 'rxjs';
import { JsonConvert } from 'json2typescript';
import { environment } from '../../../environment/environment';
import { TrendSessions, TrendSessionsData } from '../../model/trend/sessions/sessions';
import { Tenant, TenantData } from '../../model/tenant/tenant';

@Injectable({
    providedIn:'root'
})

export class TenantService{
    private _url:string = `${environment.baseAPI}/god/tenants`;
    constructor(private _http: HttpClient,private _httpUtils: HttpUtilsService){}

    GETTenant():Observable<Tenant | any>{
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}`,{ headers: httpHeaders }).pipe(
                        map((res:any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: TenantData = jsonConvert.deserializeObject(res, TenantData);
                            if (response.success) {
                                return response;
                            } else {
                                this._httpUtils.handleError(response);
                                return;
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }
}